module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-11.d5f10cda.png";